import { h } from "preact";
import { t, translate } from "restaumatic-client";
import { observer } from "mobx-react";
function formatUnavailabilityStatus(availableRangesNow) {
    if (availableRangesNow.isEmpty) {
        return translate(t.theme_defaults.dish_label.unavailable);
    }
    return availableRangesNow.raw.map((x) => x.toString()).join(", ");
}
function SectionItemAvailabilityBadge({ availableRangesNow, }) {
    return (h("span", { class: "label label-dish m-availability__label m-availability__label--unavailable" },
        formatUnavailabilityStatus(availableRangesNow),
        h("span", { class: "icon-info-sign", "aria-label": translate(t.theme_defaults.theme.informations) })));
}
export default observer(SectionItemAvailabilityBadge);
